// @ts-nocheck
export function addClasses(...args: string[]): string {
  return args.filter((item) => !!item).join(" ");
}

/**
 * Finds if any element of targetArray is inside sourceArray
 *
 * @param {Array<string>} sourceArray - Array of strings
 * @param {Array<string>} targetArray - Array of strings
 * @param {boolean} [all=false]
 * @returns {boolean}
 */
export function listIncludes<T>(sourceArray: T[], targetArray: T[], all: boolean = false): boolean {
  if (!targetArray) {
    console.warn("list includes : empty target");
    return false;
  }
  if (all) {
    return targetArray.every((item) => sourceArray.includes(item));
  }
  return targetArray.some((item) => sourceArray.includes(item));
}

export function hasAnyItems<T>(sourceArray: T[], ...items: T[]): boolean {
  if (!items) {
    console.warn("has any items : empty target");
    return false;
  }
  return items.some((element) => sourceArray.includes(element));
}

export function oneOf<T>(item: T, list: T | T[], ...rest: T[]): boolean {
  if (!list) {
    console.warn("oneOf : empty list");
    return false;
  }
  if (Array.isArray(list)) {
    return list.includes(item);
  }
  const items = [list, ...rest];
  return items.includes(item);
}

export function hasAction(campaign, type) {
  return campaign?.actions?.find((action) => action.type === type);
}

export function isAdmin(user) {
  return user?.profile === "ADMIN";
}

export function isBooster(user) {
  return user?.profile === "BOOSTER" && !window.premium;
}

export function csvLength(file, setter) {
  if (file) {
    const reader = new FileReader();
    reader.onload = () => {
      const rows = (reader.result || "")
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);

      if (!rows.length) {
        setter(0);
        return;
      }

      setter(Math.max(rows.length - 1, 0));
    };
    reader.readAsText(file);
  } else {
    setter(0);
  }
}
